var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main admin g_main"},[_c('LayoutHeader'),_c('LayoutContent'),_c('LayoutFooter'),_c('SupportBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }